// extracted by mini-css-extract-plugin
export default {"icon":"profile_icon__SvhQT"};